import { render } from "./SurveyNotFound.vue?vue&type=template&id=54403d10&ts=true"
import script from "./SurveyNotFound.vue?vue&type=script&lang=ts"
export * from "./SurveyNotFound.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__